import SearchCommissions from '@/views/Commission/SearchCommissions'

export default [
  {
    path: '/commission/search',
    name: 'commission-search',
    component: SearchCommissions
  }
]
